<div class="duedate-main">
    <label>DUE ON</label>
    <div >
        <!-- this formatted date should not be changed because it is a parameter to the datepicker -->
        <core-helpers-forms-datepicker
            [theme]="'dp-duedate'"
            [selectedDate]="date | date: 'yyyy-MM-dd'"
            (selectDate)="onSelectDate($event)"
        ></core-helpers-forms-datepicker>
    </div>
</div>
